export const environment = {
  name: 'prod',
  production: true,
  API_URL: 'https://app.amy.pro/api/',
  LOCATION_URL: 'https://app.amy.pro/aum-location/',
  WEBAPP_URL: 'https://app.amy.pro/api/',
  DATA_CENTER_TOKEN: '9c8b1195-e08f-4f6a-a54c-2abad8cfcd86',
  CAPTCHA_SITE_KEY: '6LdBMxApAAAAAPGW_ugON20DQRWrWzmp0_Wy22Ff',
  WEB_URL: 'https://app.amy.pro/',
  WEBSITE_URL: 'https://amy.pro/',
  locales: 'http://localhost:5000/',
  browserDirPath: 'dist/browser',
  imgpathUrl : "https://aumnicsaiwebsitedatastore.s3.amazonaws.com/aumnics-website",
  CMS_APPS_URL: 'https://cms.amy.pro/',
  careersAccessToken : 'CA-VSVLKFY0C6IF',
  newsAndMediadAccessToken : 'NM-W1AC3OZ25G9K',
  blogsAccessToken: 'BL-B5R3BWEYCT5Y',
  showGoogleTagManager : true,
  cookieDomain : 'amy.pro',
  AMY_BOT_URL: 'https://bot.amy.pro',
  AMY_BOT_ID: 'amy-bot'
};
